<h2 class="comp-title" style="margin-bottom: 25px;">login</h2>

<div class="login">
  <div class="login-wrapper">
  <div class="login-header">
    <h2>כיף לראות אותך</h2>
  </div>
  <div class="content">
    <mat-tab-group animationDuration="0ms" [disableRipple]="true" class="" >
      <mat-tab label="כניסה עם תעודת זהות">
      <div class="id-form">
        <span class="sub-title">נכנסים לאזור האישי עם קוד חד פעמי שמקבלים לנייד</span>
        <form class="example-form">
          <mat-form-field class="example-full-width">
            <mat-label>מספר תעודת זהות או דרכון</mat-label>
            <input matInput placeholder="" value=""  [formControl]="text">
            <mat-error>נא למלא עד 9 ספרות, כולל ספרת ביקורת ללא אותיות</mat-error>
          </mat-form-field>
        </form>
        <div class="button-wrapper">
          <a href="#" class="brand-button solid-button-black"><span>שלחו לי קוד לנייד</span></a>
          <span class="kosher-phone">לנייד "כשר" הקוד יגיע בשיחת טלפון</span>
        </div>
      </div>
      </mat-tab>
      <mat-tab label="כניסה עם סיסמה">
        <div class="password-form">
          <form class="example-form">
            <mat-form-field class="example-full-width">
              <mat-label>שם משתמש</mat-label>
              <input matInput placeholder="" value="" [formControl]="text">
              <mat-error>הודעת שגיאה</mat-error>
              <a href="#" title="" class="info-tip"></a>
            </mat-form-field>
            <mat-form-field class="example-full-width">
              <mat-label>סיסמא</mat-label>
              <input matInput placeholder="" value=""[formControl]="text" >
              <mat-error>הודעת שגיאה</mat-error>
              <span class="show-password passwordVisible"></span>
              <a href="#" title="" class="info-tip"></a>
            </mat-form-field>
          </form>
          <div class="link-wrapper">
            <a href="#" class="link forgot"  title="">אוי, שכחתי</a>
          </div>

          <div class="button-wrapper">
            <a href="#" class="brand-button solid-button-black"><span>לכניסה לאזור האישי</span></a>
            <span class="sign-in">עדיין לא נרשמתם לאזור האישי? <a href="#" class="link" title="">הירשמו עכשיו</a> </span>
          </div>
        </div>
      </mat-tab>
  </mat-tab-group>
  </div>
</div>
</div>